let lib = {
	'Value must be identical to the "{}" field value': {
		ru: 'Значение должно быть идентичным значению поля "{}"'
	},
	'Value must exceed the "{}" field value': {
		ru: 'Значение должно быть больше значения поля "{}"'
	},
	'Value must not exceed the "{}" field value': {
		ru: 'Значение не должно быть больше значения поля "{}"'
	},
	'Either this or "{}" field must have a value': {
		ru: 'Должно быть заполнено это поле или поле "{}"'
	},
	'Only one value must present here or for field: "{}"': {
		ru: 'Должно быть заполнено либо только это поле, либо только поле "{}"'
	},
	'Passwords must match': {
		ru: 'Пароли должны совпадать'
	},
	'Please use required format': {
		ru: 'Пожалуйста, используйте требуемый формат'
	},
	'Please use a valid format': {
		ru: 'Пожалуйста, используйте требуемый формат'
	},
	'Value required': {
		ru: 'Требуется значение'
	},
	'Please enter a valid E-mail': {
		ru: 'Пожалуйста, введите E-mail'
	}
}

	// 'Either one value must present here or for field: "{}"': {
	// 	ru: 'Должно быть заполнено это поле или поле "{}"'
	// },


function i18n( lang, message, args ){

	message = (
		(lib[ message ] && lib[ message ][ lang ])
		? lib[ message ][ lang ]
		: message
	);
	return message.replace( /\{\}/g, () => args.shift() )

}

export default {

	ru: ( message, args ) => i18n( 'ru', message, args )

}
